module.exports = __webpack_public_path__ + "img/5.c524e3f8.webp";